import { isAfter, isBefore } from 'date-fns'
import CONSTANTS from '@/constants'

const { LIVE_VIRTUAL_TRAININGS } = CONSTANTS

export const liveVirtualTrainingsHydratation = LVTCollection => {
  LVTCollection?.forEach(liveVirtualTraining => {
    liveVirtualTraining.product_type = 'live_virtual_training'
    switch (liveVirtualTraining.merchant_id) {
      case LIVE_VIRTUAL_TRAININGS.CCIE_SECURITY_V6:
        Object.assign(liveVirtualTraining, {
          instructorName: 'Rohit Pardasani',
          startDate: 'September 11',
          endDate: 'September 15',
          year: '2023',
          schedule: '11am - 1pm ET',
        })
        break
      case LIVE_VIRTUAL_TRAININGS.LVT_CHATGPT_AND_IA:
        Object.assign(liveVirtualTraining, {
          instructorName: 'Tim Warner',
          startDate: 'March 20',
          endDate: 'March 22',
          year: '2024',
          schedule: '1pm - 3pm ET',
        })
        break
      case LIVE_VIRTUAL_TRAININGS.LVT_ACI:
        Object.assign(liveVirtualTraining, {
          instructorName: 'Brian McGahan',
          startDate: 'June 03',
          endDate: 'June 05',
          year: '2024',
          schedule: '10am - 4pm ET',
          includedFeature: '+ 30 days of Premium',
          includedFeatureDetail: 'Starts on day 1 of training',
        })
        break
      case LIVE_VIRTUAL_TRAININGS.LVT_CCNA:
        Object.assign(liveVirtualTraining, {
          instructorName: 'Keith Bogart',
          startDate: 'June 03',
          endDate: 'June 07',
          year: '2024',
          schedule: '10am - 4pm ET',
          includedFeature: '+ 30 days of Premium',
          includedFeatureDetail: 'Starts on day 1 of training',
        })
        break
      case LIVE_VIRTUAL_TRAININGS.LVT_CCIE:
        Object.assign(liveVirtualTraining, {
          instructorName: 'Brian McGahan',
          startDate: 'July 29',
          endDate: 'August 02',
          year: '2024',
          schedule: '10am - 4pm ET',
          includedFeature: '+ 30 days of Premium',
          includedFeatureDetail: 'Starts on day 1 of training',
        })
        break
      case LIVE_VIRTUAL_TRAININGS.LVT_AWS:
        Object.assign(liveVirtualTraining, {
          instructorName: 'Alexis Ahmed',
          startDate: 'May 13',
          endDate: 'May 15',
          year: '2024',
          schedule: '1pm - 5pm ET',
          includedFeature: '+ 30 days of Premium',
          includedFeatureDetail: 'Starts on day 1 of training',
        })
        break
      case LIVE_VIRTUAL_TRAININGS.LVT_CCIE_V6_1:
        Object.assign(liveVirtualTraining, {
          instructorName: 'Rohit Pardasani',
          startDate: 'March 11',
          endDate: 'March 15',
          year: '2024',
          schedule: '10am - 4pm ET',
          includedFeature: '+ 30 days of Premium',
          includedFeatureDetail: 'Starts on day 1 of training',
        })
        break
      default:
        break
    }
  })
  LVTCollection?.sort((lvtA, lvtB) => {
    const startDateA = `${lvtA.startDate}, ${lvtA.year}`
    const startDateB = `${lvtB.startDate}, ${lvtB.year}`
    if (isBefore(new Date(startDateA), new Date(startDateB))) {
      return -1
    }
    if (isAfter(new Date(startDateA), new Date(startDateB))) {
      return 1
    }
    return 0
  })
  LVTCollection[0].upNext = true
}
